import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from 'sonner';
import { UiThemeProvider, useUiTheme } from '@/context/UiThemeContext';

// Suppress noisy ResizeObserver dev-time errors that ReactFlow can trigger
if (typeof window !== 'undefined') {
  const ignoreResizeObserverError = (event) => {
    const message = event?.message || event?.error?.message || event?.reason?.message || '';
    if (
      typeof message === 'string' &&
      (message.includes('ResizeObserver loop completed with undelivered notifications.') ||
        message.includes('ResizeObserver loop limit exceeded'))
    ) {
      event.stopImmediatePropagation();
      if (event.preventDefault) event.preventDefault();
    }
  };

  window.addEventListener('error', ignoreResizeObserverError);
  window.addEventListener('unhandledrejection', ignoreResizeObserverError);
}

function ThemedToaster() {
  const { theme } = useUiTheme();
  return <Toaster position="top-right" theme={theme} richColors />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UiThemeProvider>
    <App />
    <ThemedToaster />
  </UiThemeProvider>
);
